import { NavLink, useRouteError } from "react-router-dom";

export const ErrorPage = () => {
  const error = useRouteError();
  console.log(error);

  return (
    // <div className="loginscreen">
    //   <h1>page not found</h1>
    //   <h6>{error?.error?.message}</h6>
    //   <h6>{error?.status}</h6>
    //   <h3>{error && error?.statusText}</h3>
    //   <ul>
    //     <NavLink to={"/"}>
    //       <li>Home</li>
    //     </NavLink>
    //   </ul>
    // </div>
    <div class="loginscreen ">
      <div className="text-center error">
        <h1 className="errorDiv">{error?.status}</h1>
        <h3>Page {error && error?.statusText}</h3>
        {/* <div class="animation">😢</div> */}

        <>
          {/* <div className="errorDiv">
            <h3>
              {error?.status} <br /> !!
            </h3>
          </div> */}
        </>
        <h6>{error?.error?.message}</h6>

        <NavLink to={"/"}>
          <button>Home</button>
        </NavLink>
      </div>
    </div>
  );
};
